import { List } from 'react-md'
import { StandardCard } from 'ui/StyledComponents/Cards'
import { reportItems } from './constants'
import ReportListItem from './ReportListItem'

const ReportList = () => {
	return (
		<div className="full-height full-width" style={{ background: '#F7F7F7' }}>
			<div
				className="flex-column margin-left margin-right"
				style={{ alignItems: 'center' }}
			>
				<StandardCard
					className="margin-top margin-bottom"
					style={{ width: '100%' }}
				>
					<List>
						{reportItems.map((item, i) => (
							<ReportListItem
								key={item.key}
								item={item}
								isLast={i === reportItems.length - 1}
							/>
						))}
					</List>
				</StandardCard>
			</div>
		</div>
	)
}

export default ReportList
